const RelationType = {
  Team: 'Team',
  Company: 'Company',
  Contact: 'Contact',
};

export default RelationType;
